import { render, staticRenderFns } from "./previewDialog.vue?vue&type=template&id=f8b283e6&"
import script from "./previewDialog.vue?vue&type=script&lang=ts&"
export * from "./previewDialog.vue?vue&type=script&lang=ts&"
import style0 from "./previewDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports